import React from 'react';
import { Modal, RedDivider } from 'src/features/common';
import { Button } from '@vfs-digital-channels/ns-react-components';
import './error-modal.scss';

interface Props {
  visible: boolean;
  onVisible?: () => void;
  onClose: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  heading: string;
  subtext?: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  errorMessage?: string;
  showOR?: boolean;
}

const addLineBreaks = (text: string) =>
  text.split('\n').map((value: string, index: number) => <p key={index}>{value}</p>);

export default function ErrorModal(props: Props) {
  return (
    <Modal onClose={props.onClose} visible={props.visible} size={'small'}>
      <section className="flex flex-col items-center gap-7">
        <h1 className="text-4xl font-medium">{props.heading}</h1>
        {props.errorMessage && (
          <section className="flex flex-col items-center text-red-600">
            {addLineBreaks(props.errorMessage)}
          </section>
        )}
        <h3 className="text-lg font-normal text-center">{props.subtext}</h3>
        <RedDivider />
        <section className="flex flex-col items-center w-4/5 gap-7">
          {props.onConfirm && (
            <Button
              variant="primary"
              size="md"
              buttonType="round"
              className="w-56"
              onClick={props.onConfirm}
            >
              {props.confirmButtonLabel || ''}
            </Button>
          )}

          {props.showOR && <p className="text-lg font-bold">OR</p>}
          {props.onCancel && (
            <Button
              variant="outline"
              size="md"
              buttonType="round"
              className="w-56"
              onClick={props.onCancel}
            >
              {props.cancelButtonLabel || ''}
            </Button>
          )}
        </section>
      </section>
    </Modal>
  );
}
